const DeviceType = {
  Lamp: 1,
  Boiler: 2,
  Curtain: 3,
  Ventilator: 4,
  Dooya: 5,
  Rono: 6,
};

const MQTTCommand = {
  StateChanged: 'd',
  SettingMode: 's',
  Control: 'c',
  ControlPower: 'cp',
  ControlSetting: 'cs',
  VirtualControl: 'vc',
  VirtualSwitchSetting: 'vss',
  VirtualSwitchControl: 'vsc',
  /** 가상버튼↔물리버튼 바인딩 토글 결과 (서버→앱) */
  VirtualBoundControl: 'vbc',
  Version: 'v',
  Ping: 'p',
  /** DB 저장 후 mqtt-server가 보드로 cmd ui를 다시 보내게 요청 */
  UserInfoRefresh: 'uir',

  /**
   * //펌웨어 업데이트 요청
   * {
        "serial":	"M01_30c6f7f58cf0",
        "cmd":	"f",
        "type":	1,
        "new_version":	10105,
        "firmware_url": "http://aaaaa"
      }
   */
  FirmwareUpdateRequest: 'f',

  /**
   * //펍웨어 업데이트 시작됨
   * {
        "serial":	"M01_30c6f7f58cf0",
        "cmd":	"fs",
        "type":	1,
        "new_version":	10105,
      }
   */
  FirmwareUpdateStarted: 'fs',

  /**
   * //펌웨어 업데이트 종료됨 
   * {
        "serial":	"M01_30c6f7f58cf0",
        "cmd":	"fe",
        "type":	1,
        "new_version":	10105,
      }
   */
  FirmwareUpdateFinished: 'fe',
};
const MQTTTempCommand = {
  TempTargetSet : "TEMPTARGETSET",
  PatternModeSet : "PATTERNMODESET",  
  PatternMode2xSet : "PATTERNMODE2XSET",
  AwayModeSet : "AWAYMODESET",
  RoomTempReal: "ROOMTEMPREAL",
  PowerRl: "POWER_RL",
  TimeOnCycleSet: "TIMEONCYCLESET",
  TimeOffCycleSet: "TIMEOFFCYCLESET",
  /** 에어컨 패턴 P5 ON/OFF 분 (xsns_83 air_on_count / air_off_count) */
  AirOnCycleSet: "AIRONCYCLESET",
  AirOffCycleSet: "AIROFFCYCLESET",
  IsScanCount: "ISSCANCOUNT",
  TempCalibrationSet: "TEMPCALIBRATIONSET",
  ScheduleSyncSet : "SCHEDULESYNCSET",
  TimerGroupEnable: "TIMERGROUPENABLE",
  TimerGroupEnable1: "TIMERGROUPENABLE1",
  TimerGroupEnable2: "TIMERGROUPENABLE2",
  TimerGroupEnable3: "TIMERGROUPENABLE3",
  SyncTimerGroup: "SYNC/TIMERGROUP",
  SyncTimerGroup1: "SYNC/TIMERGROUP1",
  SyncTimerGroup2: "SYNC/TIMERGROUP2",
  SyncTimerGroup3: "SYNC/TIMERGROUP3",
  Upgrade: "UPGRADE",
  HcModeToggle: "ISHCMODETOGGLE",
  AirconPower: "ISAIRCONPOWER",
  AirconWindSpeed: "ISAIRCONWINDSPEED",
  AirconOper: "ISAIRCONOPER",
  AirconSetPoint: "ISSETPOINT",
  AirconTempTarget: "ISAIRCONTEMPTARGET",
  CoolingTempSet: "COOLINGTEMPSET",
  DarkModeSet: "DARKMODESET",
}
const MQTTCurtainCommand = {
  IsScanCount: "ISSCANCOUNT",
  IsOpen : "ISOPEN",
  IsClose : "ISCLOSE",  
  IsStop : "ISSTOP",
  IsSetClosePercent : "ISSETCLOSEPERCENT",
  IsReadPercent: "ISREADPERCENT",
  RS485AddrWrite: "RS485ADDRWRITE",
  RS485Addr: "RS485ADDR",
  IsWriteAddress: "ISWRITEADDRESS",
  IsWriteDirection: "ISWRITEDIRECTION",
}

const MQTTDooyaRonoCommand = {
  DooyaRegisterRequest: 'dooya_register_request',
  DooyaCtrl: "dooya_ctrl",
  DooyaRead: "dooya_read",
  DooyaAddr: "dooya_addr",
  DooyaAck: "dooya_ack",
  RonoRegisterRequest: 'rono_register_request',
  RonoCtrl: "rono_ctrl",
  RonoRead: "rono_read",
  RonoAddr: "rono_addr",
  RonoAck: "rono_ack",
}

const MQTTDooyaRonoAction = {
  Open: "open",
  Close: "close",
  Stop: "stop",
  Percent: "percent",
  BestPos: "best_pos",
  DelLimit: "del_limit",
  Factory: "factory",
  JogOpen: "jog_open",
  JogClose: "jog_close",
  DelSoftUp: "del_soft_up",
  DelSoftDn: "del_soft_dn",
  Direction: "direction",
}

const isDooyaRonoClosePercentSet = (item) => {
  const percent = item?.percent;
  return percent !== undefined && percent !== null && percent !== '';
};

const toCurtainPercentNumber = (raw, fallback = NaN) => {
  if (Array.isArray(raw)) {
    if (raw.length === 0) {
      return fallback;
    }
    const n = Number(raw[0]);
    return Number.isNaN(n) ? fallback : n;
  }
  if (raw === undefined || raw === null || raw === '') {
    return fallback;
  }
  const n = Number(raw);
  return Number.isNaN(n) ? fallback : n;
};

const clampCurtainPercent = (n) => Math.max(0, Math.min(100, Math.round(n)));

/** item.percent 또는 item.state.percent 에서 닫힘 정도(0–100) 해석 */
const resolveCurtainItemPercent = (item, fallback = 50) => {
  const fromItem = toCurtainPercentNumber(item?.percent, NaN);
  if (!Number.isNaN(fromItem)) {
    return clampCurtainPercent(fromItem);
  }
  const fromState = toCurtainPercentNumber(item?.state?.percent, NaN);
  if (!Number.isNaN(fromState)) {
    return clampCurtainPercent(fromState);
  }
  return clampCurtainPercent(fallback);
};

const isCurtainClosePercentSet = (item) => {
  if (isDooyaRonoClosePercentSet(item)) {
    return true;
  }
  const statePercent = item?.state?.percent;
  return statePercent !== undefined && statePercent !== null && statePercent !== '';
};

const isRonoClosePercentSet = isDooyaRonoClosePercentSet;

const getDooyaRonoCtrlData = (item, command) => {
  const addr = parseInt(item.address, 10);
  if (command === MQTTCurtainCommand.IsClose && isDooyaRonoClosePercentSet(item)) {
    return {
      addr,
      action: MQTTDooyaRonoAction.Percent,
      percent: parseInt(item.percent, 10),
    };
  }
  const action = command === MQTTCurtainCommand.IsClose
    ? MQTTDooyaRonoAction.Close
    : (command === MQTTCurtainCommand.IsOpen ? MQTTDooyaRonoAction.Open : MQTTDooyaRonoAction.Stop);
  return { addr, action };
};

const getRonoCtrlData = getDooyaRonoCtrlData;
const getDooyaCtrlData = getDooyaRonoCtrlData;

const getDooyaRonoCloseCtrlData = (item, close) => {
  const addr = parseInt(item.address, 10);
  if (close && isDooyaRonoClosePercentSet(item)) {
    return {
      addr,
      action: MQTTDooyaRonoAction.Percent,
      percent: parseInt(item.percent, 10),
    };
  }
  return {
    addr,
    action: close ? MQTTDooyaRonoAction.Close : MQTTDooyaRonoAction.Open,
  };
};

const SettingMode = {
  InSettingMode: 1,
  OutSettingMode: 0,
};

const DeviceDefault = {
  AP_Host: 'http://192.168.4.1',
  AP_SSID: 'inshowled',
  AP_PWD: 'inshow22',
};

const PowerState = {
  On: 1,
  Off: 0,
};

const Template = {
  ZoneNames: ['우리집', '마이홈', '아파트', '직접 입력'],
  GroupNames: [
    '거실',
    '안방',
    '주방',
    '현관',
    '화장실',
    '서재',
    '침실',
    '직접 입력',
  ],
};

const FadeList = [
  {
    value: 0,
    text: "없음",
  },
  {
    value: 1,
    text: "매우 빠름"
  },
  {
    value: 2,
    text: "빠름"
  },
  {
    value: 3,
    text: "보통"
  },
  {
    value: 4,
    text: "느림"
  },
  {
    value: 5,
    text: "매우 느림"
  },
];

const SensitivityList = [
  {
    value: 1,
    text: "매우 낮음"
  },
  {
    value: 2,
    text: "낮음"
  },
  {
    value: 3,
    text: "보통"
  },
  {
    value: 4,
    text: "높음"
  },
  {
    value: 5,
    text: "매우 높음"
  },
];

const SettingConfig = {
  requestCount: 10,
  requestInterval: 5000
};

const ButtonConfig = {
  delay: 1000,
  delayBatch: 2000
}
const AirconPowerConfig = {
  cooldownMs: 5000,
};

/** 에어컨(냉방) HC 모드 전환을 지원하는 온도조절기 모델 */
const AIRCON_SUPPORTED_MODELS = ['T02'];

const CONTROLLER_MODELS = {
  BLE_SUPPORTED: [
    { model: 'M24', desc: '12채널 M24(V4)' },
    { model: 'M22', desc: '12채널 M22(V3)' },
    { model: 'M02', desc: '12채널 M02(V2)' },
    { model: 'M31', desc: '4채널 M31' },
    { model: 'M91', desc: '모드스위치 M91' },
    { model: 'M11', desc: '라우터 M11' },
  ],
  WIFI_SUPPORTED: [
    { model: 'M02', desc: '12채널 M02(V2)' },
    { model: 'M22', desc: '12채널 M22(V3)' },
  ],
};

const lightButtonColors = [
  "#f4d110",
  "#f2d94e",
  "#ffe96f",
  "#fff3af",
  "#fffade",
  "#f0fffc",
  "#dbf2fc",
  "#c4eafb",
  "#b7e5fc",
  "#9ee0fc",
  "#7ad3f9"
];

const lightButtonAnotherColors = [
  "rgba(244, 210, 16, 0.5)",
  "rgba(242, 217, 78, 0.5)",
  "rgba(255, 233, 111, 0.4)",
  "rgba(255, 243, 175, 0.3)",
  "rgba(255, 250, 245, 0.3)",
  "rgba(255, 255, 255, 0.3)",
  "rgba(239, 242, 252, 0.3)",
  "rgba(196, 234, 251, 0.3)",
  "rgba(183, 229, 252, 0.4)",
  "rgba(158, 224, 252, 0.5)",
  "rgba(122, 211, 249, 0.5)",
];

const parseBoilerRelayOn = (value) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toUpperCase();
    if (normalized === 'ON') return 1;
    if (normalized === 'OFF') return 0;
    return undefined;
  }
  const raw = value.POWER_RL ?? value.POWER1 ?? value.POWER;
  if (raw === undefined || raw === null) {
    return undefined;
  }
  return String(raw).trim().toUpperCase() === 'ON' ? 1 : 0;
};

module.exports = {
  DeviceType,
  MQTTCommand,
  MQTTTempCommand,
  MQTTCurtainCommand,
  MQTTDooyaRonoCommand,
  MQTTDooyaRonoAction,
  isDooyaRonoClosePercentSet,
  isRonoClosePercentSet,
  isCurtainClosePercentSet,
  resolveCurtainItemPercent,
  getDooyaRonoCtrlData,
  getDooyaCtrlData,
  getRonoCtrlData,
  getDooyaRonoCloseCtrlData,
  SettingMode,
  PowerState,
  DeviceDefault,
  Template,
  FadeList,
  SensitivityList,
  SettingConfig,
  ButtonConfig,
  AirconPowerConfig,
  AIRCON_SUPPORTED_MODELS,
  lightButtonColors,
  lightButtonAnotherColors,
  CONTROLLER_MODELS,
  parseBoilerRelayOn,
};
